<template>
  <!-- loading: a row of skeleton cards (1 / 2 / 3 to match the responsive
       slides), each a white card box with a loader -->
  <div v-if="loading" class="d-flex">
    <div
      v-for="n in 3"
      :key="`hotel-skeleton:${n}`"
      class="hotels-skeleton__card px-2"
      :class="{ 'd-none d-md-block': n === 2, 'd-none d-xl-block': n === 3 }"
    >
      <div class="hotels-skeleton__box">
        <div style="opacity: 0" aria-hidden="true">
          <invadobay-property-card
            :property="{
              thumbnail_url:
                '/assets/images/common/statics/room_placeholder.png',
              name: '---',
            }"
            :card="{ image_style: { 'min-height': '200px' } }"
            :checkin="moment()"
            :checkout="moment()"
            is_placeholder
          />
        </div>
        <div class="hotels-skeleton__loader">
          <loader />
        </div>
      </div>
    </div>
  </div>

  <!-- empty -->
  <div v-else-if="properties.length === 0" class="hotels-empty">
    Nessuna proposta
  </div>

  <!-- hotels carousel: 3 per view on large, 2 on medium, 1 on mobile, paging
       by a full group each time -->
  <swiper
    v-else
    :ref_id="`hotels_container:${invadobay.id}`"
    :swiper_params="swiper_params"
  >
    <template>
      <swiper-slide
        v-for="property in properties"
        :key="`hotel:${invadobay.id}:${property.property_id || property.name}`"
        class="px-2 pb-lg-0 pb-2"
      >
        <invadobay-property-card
          :property="property"
          :checkin="checkin"
          :checkout="checkout"
          :card="{ image_style: { 'min-height': '200px' } }"
        />
      </swiper-slide>
    </template>
  </swiper>
</template>

<script>
import moment from "moment";
import Swiper from "@/components/blocks/swiper.vue";
import InvadobayPropertyCard from "./invadobay-property-card.vue";

export default {
  name: "invadobay-search-preview-hotels",
  components: {
    swiper: Swiper,
    "invadobay-property-card": InvadobayPropertyCard,
  },
  props: {
    invadobay: {
      type: Object,
      default: Object,
    },
    properties: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
    checkin: {
      type: Object,
      default: Object,
    },
    checkout: {
      type: Object,
      default: Object,
    },
  },
  computed: {
    swiper_params() {
      return {
        button_offset: 15,
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        // Hide the arrows when there's nothing to scroll; the swiper wrapper
        // also hides them per-breakpoint once every slide fits.
        hide_controls: this.properties.length <= 1,
        breakpoints: {
          768: { slidesPerView: 2, slidesPerGroup: 2 },
          1200: { slidesPerView: 3, slidesPerGroup: 3 },
        },
      };
    },
  },
  methods: {
    moment,
  },
};
</script>

<style lang="scss" scoped>
.hotels-skeleton {
  &__card {
    flex: 1 1 0;
    min-width: 0;
  }

  &__box {
    position: relative;
    height: 100%;
    background-color: white;
    border-radius: 0.626rem;
  }

  &__loader {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.hotels-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background-color: white;
  border-radius: 0.626rem;
  text-align: center;
}
</style>
